import { connectBaseApi, vrpRoutingClient, createRpcMutation } from "@racoon/api";

const vrpRoutingGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    solveSingleVehicle: createRpcMutation(build, vrpRoutingClient, "solveSingleVehicle"),
  }),
  overrideExisting: false,
});

export const { useSolveSingleVehicleMutation } = vrpRoutingGrpc;
